// extracted by mini-css-extract-plugin
export default {"cursor":"custom-cursor_cursor__MhK-i","hidden":"custom-cursor_hidden__O5i2p"};